import React from 'react';
import styles from 'new/components/collaborate/org/OrgDetail.module.scss';
import { OrgBanner } from 'new/elements/OrgBanner';
import { useSelector } from 'react-redux';
import { ResourceShare } from 'new/elements/ResourceShare';
import { useLocation } from 'react-router-dom';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_COLLABORATE_ORG } from 'new/constants/pathnames';

interface OrgProps {
  match: {
    params: {
      id: string;
    };
  };
}

export const OrgDetail: ScreenComponent<OrgProps> = (props: OrgProps) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  // @ts-ignore
  const org = useSelector((state) => state.entities.orgs[query.get('orgId')]);
  return (
    <div className={styles.container}>
      <OrgBanner className={styles.banner} org={org} />
      <ResourceShare org={org} />
    </div>
  );
};

OrgDetail.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE_ORG}/:id`,
  domain: 'collaborate',
  screenName: 'OrgDetail',
};
